import { render, staticRenderFns } from "./marketGoodsItemManageList.vue?vue&type=template&id=6606f5b3&scoped=true"
import script from "./marketGoodsItemManageList.vue?vue&type=script&lang=js"
export * from "./marketGoodsItemManageList.vue?vue&type=script&lang=js"
import style0 from "./marketGoodsItemManageList.vue?vue&type=style&index=0&id=6606f5b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606f5b3",
  null
  
)

export default component.exports